<sf-card [cardTitle]="chartTitle">
    <apx-chart
        #chartspark1
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [stroke]="chartOptions.stroke"
        [yaxis]="chartOptions.yaxis!"
        [xaxis]="chartOptions.xaxis!"
        [fill]="chartOptions.fill!"
        [colors]="chartOptions.colors!"
        [subtitle]="chartOptions.subtitle!"></apx-chart>
</sf-card>
